import { CLPL } from '../../constants/measure';
import * as apiActions from '../api/apiActions';

class CLPLServiceClient {
    static MEASURES = [CLPL.MEASURE];

    static URL = '/clpl-api/v1';

    /**
    * Constructs request url to CLPL service based on the passed config object.
    * config may include:
        - formId
        - grage
        - period
    */
    static constructFormEndpoint({ formId, grade, period }) {
        let endpoint = `${CLPLServiceClient.URL}/forms`;

        if (formId) {
            return `${endpoint}/${formId}`;
        }

        const params = [];
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }

        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({ studentId, grade, period, schoolYear } = {}) {
        let endpoint = `${CLPLServiceClient.URL}/results`;
        const params = [];
        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade_level=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructResultEndpoint(resultId) {
        return `${CLPLServiceClient.URL}/results/${resultId}`;
    }

    /**
     * Construct save CLPL online result endpoint
     */
    static constructSaveResultEnpoint() {
        return `${CLPLServiceClient.URL}/online_result`;
    }

    /**
     * Sends GET request to endpoint with provided parameters
     * @param {str} grade - (optional) student's grade
     * @param {str} period - (optional) BOY | MOY | EOY
     * @param {str} formId - (optional) assessment form ID
     * @returns {JSON} server response
     */
    static getForm = (grade, period, formId, retryActionName) => dispatch => {
        const config = {
            grade,
            period,
            formId,
        };

        const endpoint = CLPLServiceClient.constructFormEndpoint(config);
        return dispatch(apiActions.makeRetriableGetRequest(endpoint, retryActionName));
    };
}

export default CLPLServiceClient;
